module.exports = __webpack_public_path__ + "img/lipigo_6.4f5e436a.png";